// Copyright (c) 2022 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../trash/slice"
import { EMPTY_TRASH_DO_NOT_ASK_AGAIN_KEY } from "../../../app/localStorageKeys"

export type StorageReader = () => Observable<boolean>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(EMPTY_TRASH_DO_NOT_ASK_AGAIN_KEY)
    if (data !== null) {
      return of(Boolean(data))
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadEmptyTrashDoNotAskAgain = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.loadEmptyTrashDoNotAskAgainFromStorage.match),
      mergeMap(_ => load().pipe(
        map(Slice.setEmptyTrashDoNotAskAgain),
        catchError(_ => of(Actions.loadEmptyTrashDoNotAskAgainFromStorageFailed())),
      )),
    )

export default loadEmptyTrashDoNotAskAgain(load)

